import RestService from 'restService';

export default class Info {
  public version: string;

  public year: string;

  public async load() {
    const response = await RestService.get('/info', false);
    this.version = response.version;
    this.year = response.year;
  }
}
